import { OrderStatusEnum } from "src/enums/order.enum";
import { getOrderStatusStyle } from "src/constants/orderStatusBadges";
import {
  orderDrawerPrimaryButtonClass,
  orderDrawerSecondaryButtonClass,
} from "src/constants/orderDrawerButtons";
import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";

export interface ConfirmOrderStatusChangeModalProps {
  open: boolean;
  pendingStatus: OrderStatusEnum | null;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

/**
 * Same intent as eatsbitsdesktop OrderDetailsController.handleStatusChange confirmation:
 * title "Confirm Status Change", message with quoted status label, Confirm / Cancel.
 */
export function ConfirmOrderStatusChangeModal({
  open,
  pendingStatus,
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmOrderStatusChangeModalProps) {
  if (!open || pendingStatus == null) return null;

  const statusLabel = getOrderStatusStyle(pendingStatus).label;

  return (
    <PortaledModalFrame
      onClose={isLoading ? () => {} : onCancel}
      panelClassName="max-w-md"
      panelStyle={{ maxWidth: 420 }}
    >
      <div className="px-6 py-5">
        <h2 id="modal-title" className="text-lg font-semibold text-[#111827]">
          Confirm Status Change
        </h2>
        <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">
          Are you sure you want to change the order status to &quot;{statusLabel}&quot;?
        </p>
        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className={orderDrawerSecondaryButtonClass}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => void onConfirm()}
            disabled={isLoading}
            className={orderDrawerPrimaryButtonClass}
          >
            {isLoading ? "Updating…" : "Confirm"}
          </button>
        </div>
      </div>
    </PortaledModalFrame>
  );
}
